import { render, staticRenderFns } from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=template&id=471f6a57"
import script from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=script&lang=ts"
export * from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=script&lang=ts"
import style0 from "./LeakageCauseOutsideHouseQuestion.vue?vue&type=style&index=0&id=471f6a57&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports